import { useLocation } from 'react-router-dom';
// @mui
import { AppBar, Box, Container, Toolbar, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';
import useResponsive from '../../hooks/useResponsive';
// routes
// utils
import cssStyles from '../../utils/cssStyles';
// config
import { HEADER } from '../../config';
// components
import Logo from '../../components/Logo';
import LanguagePopover from '../../components/LanguagePopover';
// sections
import navSimpleConfig from './MenuSimpleConfig';
import MenuSimpleDesktop from './MenuSimpleDesktop';
import MenuSimpleMobile from './MenuSimpleMobile';

// ----------------------------------------------------------------------

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: HEADER.MOBILE_HEIGHT,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('md')]: {
    height: HEADER.MAIN_DESKTOP_HEIGHT,
  },
}));

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8,
}));

// ----------------------------------------------------------------------

export default function MainSimpleHeader() {
  // const { translate } = useLocales();
  const isOffset = useOffSetTop(HEADER.MAIN_DESKTOP_HEIGHT);
  const theme = useTheme();
  // const navigate = useNavigate();
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'md');
  const isHome = pathname === '/';

  return (
    <AppBar sx={{ boxShadow: 0, bgcolor: 'transparent' }}>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            ...cssStyles(theme).bgBlur(),
            height: { md: HEADER.MAIN_DESKTOP_HEIGHT - 16 },
          }),
        }}
      >
        <Container
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Logo />
          <Typography variant="h5" pl={1} color={'common.black'}>
            JMT - Tracking
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

          {isDesktop && <MenuSimpleDesktop isOffset={isOffset} isHome={isHome} navConfig={navSimpleConfig} />}

          {/* <Button variant="contained" target="_blank" onClick={() => navigate(PATH_AUTH.login)}>
            {translate('header.login')}
          </Button> */}

          <LanguagePopover />

          {!isDesktop && <MenuSimpleMobile isOffset={isOffset} isHome={isHome} navConfig={navSimpleConfig} />}
        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}
